import { Component, EventEmitter, Input,OnChanges,Output, SimpleChanges  } from '@angular/core';
import { Pipe, Quantity, UnitsService } from 'pumpcalc-core';
import { Keys,Labels, Quantities } from '../gasflow.constants'

export class RangeVariable {
  id:number;
  min:number;
  max:number;
  intervals:number;
  log:boolean;
  key:string;
  pipe:number;
  quantity:string;
};

@Component({
  selector: 'app-range-variable-form',
  templateUrl: './range-variable-form.component.html',
  styleUrls: ['./range-variable-form.component.css']
})
export class RangeVariableFormComponent {

  @Input() pipes:Pipe[];
  @Input() boundaries:any;
  @Input() errors:any={};
  @Input() id=0;
  @Input() variables=[];
  @Output() valueChange: EventEmitter<RangeVariable> = new EventEmitter();

  min:number;
  max:number;
  log=false;
  intervals=10;
  keys=Keys;
  labels=Labels;
  quantity=null;
  variable=null;
  pipe=null;
  key=null;
  minMin;

  constructor(private unitsService:UnitsService) {
  }

  ngOnInit() {
    this.setminMax();
  }

  variableSelectionChanged(event){
    if(this.key == event.selectedItem.key){return;}
    this.pipe=event.selectedItem?event.selectedItem.pipe:this.pipe;
    this.key=event.selectedItem?event.selectedItem.key:this.key;
    this.quantity=event.selectedItem.quantity?event.selectedItem.quantity:Quantities[this.key];
    this.intervals=10;
    this.setminMax();
    this.announceChange();
  }

  setminMax(){
    this.min=this.quantity==Quantity.TEMPERATURE?273.15:0;
    this.max=this.quantity==Quantity.TEMPERATURE?273.15:0;
    this.minMin=this.quantity==Quantity.TEMPERATURE && this.unitsService.getSelectedUnitForQuantity(Quantity.TEMPERATURE) != "K"?undefined:0;
  }

  announceChange(){
    this.valueChange.emit({id:this.id,min:this.min,max:this.max,intervals:this.intervals,log:this.log,key:this.key,pipe:this.pipe,quantity:this.quantity});
  }

}
